import { render, staticRenderFns } from "./UpdateExCertiModal.vue?vue&type=template&id=f3099b60&"
import script from "./UpdateExCertiModal.vue?vue&type=script&lang=js&"
export * from "./UpdateExCertiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports